import { Form, Select } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import mask from '../../../../../utils/mask';
import { Props } from './props';
import { TextLabel } from 'components/TextLabel';

const { Option } = Select;

const App: React.FC<Props> = ({ setCodTomador, setNomeTomador }) => {
  const inscricaoAtiva = useSelector(
    (state: ApplicationState) => state.auth.user?.inscricoesEstaduais
  );

  const handleChange = (value: string, e: any) => {
    setCodTomador(Number(e.key));
    setNomeTomador?.(value);
  };

  return (
    <Form.Item
      name="nometomador"
      label={<TextLabel>Tomador</TextLabel>}
      rules={[{ required: true, message: 'Por favor preencha este campo!' }]}
    >
      <Select
        onChange={handleChange}
        filterOption={(inputValue, element) =>
          element?.props.children.toString().toLowerCase().includes(inputValue.toLowerCase())
        }
      >
        {inscricaoAtiva?.map((item: any) => (
          <Option key={item.codParceiro} value={item.nomeParceiro}>
            {item.nomeParceiro} <br />
            {mask('cpfCnpj', item.cnpjcpf)} <br />
            {item.inscricaoEstadual}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default App;
